exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntd.w50-column {\n    width: 50%;\n}\ntable.VueTables__table td.w50-column {\n    text-align: left;\n}\n", ""]);

// exports
